import { render, staticRenderFns } from "./AtualizarCadastro.vue?vue&type=template&id=33b3c38b&scoped=true"
import script from "./AtualizarCadastro.vue?vue&type=script&lang=js"
export * from "./AtualizarCadastro.vue?vue&type=script&lang=js"
import style0 from "./AtualizarCadastro.vue?vue&type=style&index=0&id=33b3c38b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b3c38b",
  null
  
)

export default component.exports